/**
 * @file m站首页
 */

import React, {Component} from 'react';
import {
    SAVE_CITY_GAI_INFO,
    SAVE_CITY_GET_INFO,
    SAVE_STORE_GAI_INFO,
    SAVE_STORE_GET_INFO
} from '../../redux/actions/homeAction';
import storage from 'store';
import Banner from '../../component/banner/banner';
import Search from '../../component/search/index';
import {NavBar, Toast, WingBlank, Icon} from 'antd-mobile';
import NavBarComponent from '../../component/common/NavBarComponent';
import {Http, urls} from '../../api/index';
import {connect} from 'react-redux';
import {parseSearchToState} from '../../util/util';
import {phoneType} from '../../util/base';
import './index.scss';
let mySelf = {};
class Home extends Component {
    constructor(props) {
        super(props);
        window.getToken = this.getToken;
        props.cacheLifecycles.didRecover(this.componentDidRecover);
        // 调用ios的方法，this指向丢了，重新指回来
        mySelf = this;
        this.state = {
            show: false,
            // 经纬度默认给北京
            logAndlat: {
                lng: '116.407526',
                lat: '39.90403'
            },
            loading: false,
            showBackNativeAppBtn: false,
            token: ''
        };
    }

    componentDidMount() {
        this.init();
    }

    componentDidRecover = () => {
        const {history} = this.props;
        const search = history.location.search;
        let {isRefresh} = parseSearchToState(search);
        if (isRefresh === 'refresh') {
            this.init();
        }
    }

    init() {
        this.setState(() => {
            Toast.loading('Loading...');
            return {loading: true};
        });
        this.setTime();
        this.getLocation();
        let params=parseSearchToState(window.location.search);
        if(params['car-vs']||params.APPVersion){
            this.FreeAccess();
        }
        if(params.auth_code){
            this.RuJiaFreeAccess();
        }

        /**
         * app进来的需要隐藏原生头部的需要判断这个参数
         * 有该参数则隐藏原生头部，并且首页nav处增加返回app的关闭按钮
         * app中打开，则需要调用app中暴露的方法获取token，使用token进行免登录
         */
        if (params['source'] === 'app' || storage.get('source') === 'app') {
            this.hideNativeHead();
            this.setState({
                showBackNativeAppBtn: true
            });
            storage.set('source', 'app');
            this.setChannel();
        }
    }

    /**
     * 获取token
     */
    getUserToken() {
        const u = navigator.userAgent;
        let token = '';
        // 1 Android  2 ios
        if (phoneType(u) === 1) {
            token = window.izuche.getToken();
            this.freeLogin(token);
        } else {
            window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.transferParametersForiosAction.postMessage({
                action: 'getToken'
            });
        }
        this.setState({
            token
        });
    }

    /**
     * window上注册该方法，供ios端调用传入token
     */
    getToken(token) {
        mySelf.setState({
            token
        });
        mySelf.freeLogin(token);
    }

    /**
     * 免登录
     */
    freeLogin(token) {
        let url = urls.FreeAccess;
        Http.post({url, data: {
            token
        }}).then(res => {
            storage.set('user', res.data);
        });
    }

    /**
     * 设置渠道号
     */
    setChannel() {
        let params = parseSearchToState(window.location.search);
        // url： xxx?channel=formMrCar  来源商务车队app
        if (params['channel'] === 'fromMrCar') {
            storage.set('channel', 'fromMrCar');
        }
        // url： xxx?channel=dz_app  来源短租
        else if (params['channel'] === 'dz_app') {
            storage.set('channel', 'dz_app');
        }
        this.getUserToken();
    }
    RuJiaFreeAccess(){
        let params=parseSearchToState(window.location.search);
        let url=urls.FreeAccess;
        Http.post({url, data: {
            token:params.auth_code,
            channel:'fromRuJia'
        }}).then(res=>{
            storage.set('user', res.data)
        })
    }
    FreeAccess(){
        let params=parseSearchToState(window.location.search);
        let url=urls.FreeAccess;
        Http.post({url, data: {
            customerId:params.customerid,
            token:params.token
        }}).then(res=>{
            storage.set('user', res.data)
        })
    }

    /**
     * 是否隐藏原生app头部，调用原生暴露出来的方法
     */
    hideNativeHead() {
        const u = navigator.userAgent;
        // 1 Android  2 ios
        if (phoneType(u) === 1) {
            window.izuche.hideNavigation();
        } else {
            window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.transferParametersForiosAction.postMessage({
                action: 'hideNavigation'
            });
        }
    }

    // 返回app
    goBackApp() {
        const u = navigator.userAgent;
        // 1 Android  2 ios
        if (phoneType(u) === 1) {
            window.izuche.close();
        } else {
            window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.transferParametersForiosAction.postMessage({
                action: 'back'
            });
        }
        storage.set('source', '');
    }

    setTime() {
        const now = new Date(Date.now() + 60000 + 2 * 60 * 60 * 1000);
        const tomorrow = new Date(now.getTime() + 2 * 8.64e7);
        const weekday = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
        const dateObj = this.initDate();
        let startTime = {
            year: dateObj.now.getFullYear(),
            month: dateObj.now.getMonth() + 1,
            day: dateObj.now.getDate(),
            week: weekday[dateObj.now.getDay()],
            hours: dateObj.now.getHours(),
            minutes: dateObj.now.getMinutes()
        };
        let endTime = {
            year: dateObj.tomorrow.getFullYear(),
            month: dateObj.tomorrow.getMonth() + 1,
            day: dateObj.tomorrow.getDate(),
            week: weekday[dateObj.tomorrow.getDay()],
            hours: dateObj.tomorrow.getHours(),
            minutes: dateObj.tomorrow.getMinutes()
        };
        sessionStorage.setItem('startTime', JSON.stringify(startTime));
        sessionStorage.setItem('endTime', JSON.stringify(endTime));
    }

    initDate() {
        let nowBase = Date.now() + 2 * 60 * 60 * 1000;
        let nextBase = nowBase + 2 * 8.64e7;
    
        let nowD = new Date(nowBase);
        let nextD = new Date(nextBase);
        if (nextD.getMinutes() % 30 !== 0) {
            nowD = new Date(nowBase + (30 - nowD.getMinutes() % 30) * 60 * 1000);
            nextD = new Date(nextBase + (30 - nextD.getMinutes() % 30) * 60 * 1000);
        }
        else if (nextD.getMinutes() % 30 === 0) {
            nowD = new Date(nowBase + 30 * 60 * 1000);
            nextD = new Date(nextBase + 30 * 60 * 1000);
        }
        return {
            now: nowD,
            tomorrow: nextD
        };
    }

    // 补0
    pad = time => time >= 10 ? time : `0${time}`;

    /**
     * 调用高德api当前用户获取经纬度
     */
    getLocation() {
        let self = this;
        // eslint-disable-next-line
        AMap.plugin('AMap.Geolocation', function () {
            // eslint-disable-next-line
            var geolocation = new AMap.Geolocation();
            geolocation.getCurrentPosition(function (status, result) {
                if (status === 'complete') {
                    onComplete(result);
                }
                else {
                    onError(result);
                }
            });
        });
        // 解析定位结果
        function onComplete(data) {
            self.setState(() => {
                Toast.loading('Loading...');
                return {
                    logAndlat: data.position
                };
            });
            self.getLocationCity();
        }
        // 解析定位错误信息
        function onError(data) {
            self.setState(() => {
                Toast.loading('Loading...');
            });
            self.getLocationCity();
        }
    }

    // 获取定位城市信息
    getLocationCity() {
        let {logAndlat} = this.state;
        let url = urls.getCity;
        Http.post({url, data: {
            logAndlat: `${logAndlat.lng},${logAndlat.lat}`
        }}).then(res => {
            let data = res.data;
            this.setState({
                gaiCityName: data.cityName,
                getCityName: data.cityName
            });
            
            localStorage.setItem('locationCityInfo', JSON.stringify(res.data));
            // 初始化取车城市信息
            this.props.dispatch(SAVE_CITY_GAI_INFO({gaiCityInfo: res.data}));
            // 初始化还车城市信息
            this.props.dispatch(SAVE_CITY_GET_INFO({getCityInfo: res.data}));

            sessionStorage.setItem('gaiCityInfoFromStores', JSON.stringify(res.data));
            sessionStorage.setItem('getCityInfoFromStores', JSON.stringify(res.data));
            this.getStoreInfo(data.cityId);
        });
    }

    // 根据定位获取首页门店
    getStoreInfo(cityId) {
        let {logAndlat} = this.state;
        let url = urls.getHomePageStoreInfoByStorePointAndCityId;
        Http.post({url, data: {
            cityId,
            storePoint: `${logAndlat.lng},${logAndlat.lat}`
        }}).then(res => {
            let data = res.data;
            this.setState({
                gaiStoreName: data.storeName,
                getStoreName: data.storeName
            });
            // 初始化取车门店信息
            this.props.dispatch(SAVE_STORE_GAI_INFO({gaiStoreInfo: res.data}));
            // 初始化还车门店信息
            this.props.dispatch(SAVE_STORE_GET_INFO({getStoreInfo: res.data}));
            Toast.hide();
            sessionStorage.setItem('gaiStoreInfoFromStores', JSON.stringify(res.data));
            sessionStorage.setItem('getStoreInfoFromStores', JSON.stringify(res.data));
        });
    }

    render() {
        return (
            <div className="home page">
                <NavBarComponent>
                    {
                        this.state.showBackNativeAppBtn
                        ? <NavBar
                            icon={<Icon type="cross" color='#333' />}
                            onLeftClick={() => {this.goBackApp();}}
                            mode='light'>
                                首页
                            </NavBar>
                        : <NavBar mode='light'>首页</NavBar>
                    }
                </NavBarComponent>
                <div>{ storage.get('channel')  !== 'from12306' ? <Banner /> : null }</div>
                <WingBlank>
                    <Search history={this.props.history}></Search>
                </WingBlank>
            </div>
        );
    }
}


const mapStateToProps = state => {
    let params = state.homeReducer;
    return {
        gaiCityInfo: params.gaiCityInfo,
        getCityInfo: params.getCityInfo,
        gaiStoreInfo: params.gaiStoreInfo,
        getStoreInfo: params.getStoreInfo,
        startTime: params.startTime,
        endTime: params.endTime
    };
};

Home = connect(mapStateToProps)(Home);

export default Home;
